import { render, staticRenderFns } from "./alertQuotaLimit.vue?vue&type=template&id=cf01c76a"
import script from "./alertQuotaLimit.vue?vue&type=script&lang=js"
export * from "./alertQuotaLimit.vue?vue&type=script&lang=js"
import style0 from "./alertQuotaLimit.vue?vue&type=style&index=0&id=cf01c76a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports